import { errorsSlice } from '../app/modules/Auth/_redux/errorRedux';

function replaceUUIDs(inputString, replacementText) {
  // Define a regular expression to match UUIDs
  const uuidPattern = /\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;

  // Use the replace method to replace all UUIDs with the specified replacement text
  const result = inputString.replace(uuidPattern, replacementText);

  return result;
}

const methods = {
  delete: [
    { url: '/asset-categories', statusCode: 409 },
    { url: '/areas/facilities', statusCode: 400 },
    { url: '/areas/facilities/floor-plans', statusCode: 409 },
  ],
  post: [
    { url: '/firmware', statusCode: 409 },
    { url: '/assets', statusCode: 404 },
    { url: '/assets', statusCode: 409 },
    { url: '/tags/batch', statusCode: 400 },
    { url: '/tags/batch', statusCode: 409 },
    { url: '/tags/batch', statusCode: 500 },
    { url: '/challenge-response', statusCode: 400 },
    { url: '/challenge-response', statusCode: 404 },
  ],
  put: [
    { url: '/assets', statusCode: 400 },
    { url: '/assets', statusCode: 404 },
    { url: '/assets', statusCode: 409 },
  ],
};

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const {
        auth: { user },
      } = store.getState();

      if (user && user.token) {
        config.headers.Authorization = `Bearer ${user.token}`;
      }
      config.baseURL = import.meta.env.VITE_BASE_URL;

      return config;
    },
    err => Promise.reject(err)
  );
  axios.interceptors.response.use(
    next => Promise.resolve(next),
    error => {
      const url = error.config?.url ?? '';
      const parsedURL = replaceUUIDs(url, '');
      const excludedUrls = methods[error.config?.method ?? ''];
      const excludeUrl = excludedUrls?.some(
        x =>
          parsedURL.includes(x.url) && x.statusCode === error.response?.status
      );
      if (excludeUrl) {
        console.error(JSON.stringify(error));
        return Promise.reject(error);
      }
      try {
        store.dispatch(errorsSlice.actions.catchError(error));
        return Promise.reject(error);
      } catch (error) {
        console.error(error);
      }
    }
  );
}
